<script setup lang="ts">
  import type { Task } from '@api/models';
  import { storeToRefs } from 'pinia';
  import { computed } from 'vue';

  import { Card, CardContent } from '@ui/components/card';

  import { useTaskCollectionStore } from '@/store';

  interface Props {
    task?: Task;
  }

  const props = defineProps<Props>();
  const taskCollectionStore = useTaskCollectionStore();
  const { currentTask } = storeToRefs(taskCollectionStore);
  const componentTask = computed(() => props.task ?? currentTask.value);
</script>

<template>
  <div
    v-if="componentTask?.dispute?.resolution"
    class="space-y-4"
    :class="{
      'opacity-70': !componentTask?.isOpen,
    }"
  >
    <div v-if="componentTask?.type" class="flex items-center gap-x-2">
      <i class="fas fa-star-christmas text-primary text-xs"></i>
      <strong>Resolution Description:</strong>
    </div>

    <Card>
      <CardContent class="whitespace-pre-line">
        {{ componentTask?.dispute?.resolution }}
      </CardContent>
    </Card>
  </div>
</template>

<style scoped></style>
